<template>
  <h3 class="text-center font-semibold text-gray-700">
    Resumen de la campaña (Kg)
  </h3>
  <div id="chart" class="flex md:block justify-center">
    <apexchart
      type="pie"
      width="100%"
      height="200"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "PRODReportingProcessSummary",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    data: { required: true }
  },
  data() {
    return {
      data_formatted: [
        [this.data.ok_weight, this.data.ok_percent],
        [this.data.discarded_weight, this.data.discarded_percent]
      ],
      series: [this.data.ok_percent, this.data.discarded_percent],
      options: {
        chart: { type: "pie" },
        labels: ["Exportable", "Descarte"],
        colors: ["#65A30D", "#CC3333"],
        legend: { offsetX: 50, fontSize: "14px" },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return `${this.numberWithPrecision(val, 1)}%`;
          }.bind(this),
          textAnchor: "middle",
          distributed: false,
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: "16px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: "bold",
            colors: ["#fff"]
          },
          background: {
            enabled: false,
            foreColor: "#fff",
            padding: 4,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: "#fff",
            opacity: 0.9,
            dropShadow: { enabled: false }
          },
          dropShadow: { enabled: false }
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: function (val, opts) {
              return this.numberWithPrecision(
                this.data_formatted[opts.seriesIndex][0]
              );
            }.bind(this)
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 200, height: 380 },
              legend: { position: "bottom", offsetX: 0 }
            }
          }
        ]
      }
    };
  }
};
</script>
